module.exports = __webpack_public_path__ + "assets/images/boundaries/locator-legend/desktop.svg?v=8f81ba0f";